import { render, staticRenderFns } from "./infusion.vue?vue&type=template&id=23f1c882&scoped=true&"
import script from "./infusion.vue?vue&type=script&lang=js&"
export * from "./infusion.vue?vue&type=script&lang=js&"
import style0 from "./infusion.vue?vue&type=style&index=0&id=23f1c882&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f1c882",
  null
  
)

export default component.exports